// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__oItJD","feedback":"Footer_feedback__nnrNp","text":"Footer_text__dQiTE"};